import { useEffect, useState } from 'react'

export default function SnipCart() {
  const [itemsCount, setItemsCount] = useState(0)

  useEffect(() => {
    if(!window?.Snipcart?.store){
      return null
    }
    const Snip = window?.Snipcart
    const initialState = Snip?.store?.getState()
    setItemsCount(initialState?.cart?.items?.count)

    const unsubscribe = Snip?.store?.subscribe(() => {
      const newState = Snip?.store?.getState()
      setItemsCount(newState?.cart?.items?.count)
    })

    return () => unsubscribe()
  }, [setItemsCount])

  if (typeof window === "undefined" && window?.Snipcart?.store) {
    return (
      <a href="#" className='relative flex pr-2 text-sm font-medium text-gray-500 hover:text-gray-900 snipcart-checkout'>
        <svg className="flex-none w-[27px] h-[27px] fill-current" viewBox="0 0 24 24">
          <path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z"/>
        </svg>
      </a>
    )
  }
  return (
  <a href="#" role="button" className="flex items-center justify-center snipcart-checkout" aria-label="Shopping Cart">
    <span className='relative inline-flex pr-2 '>
    <svg className="flex-none w-[27px] h-[27px] fill-current" viewBox="0 0 24 24">
      <path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z"/>
      </svg>
      {( itemsCount !== 0) && <span className="absolute -top-[7px] right-[4px] flex items-center justify-center w-[18px] h-[18px] p-0 m-0 font-mono text-[10px] text-center text-white bg-red-600 rounded-full top right leading-[normal]">{itemsCount}
    </span>}
    </span>
  </a>
  )
}
